import React, { useContext, useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import {
 Col, Modal, InputGroup, Form, 
} from 'react-bootstrap';
import { FaExclamationCircle } from 'react-icons/fa';
import { Button, ButtonToolbar, ButtonGroup } from '@/shared/components/Button';
import Pagination from 'react-bootstrap/Pagination';
import { FaArrowDownShortWide, FaArrowUpWideShort } from 'react-icons/fa6';
import toast from 'react-hot-toast';
import { AuthContext } from '../../../../../../context/AuthContext';
import ComfirmationModel from '../../../util/ComfirmationModel';
import RejectReasonForm from '../../../../../Agent/RejectReasonForm';
import BookingInfo from './Info/BookingInfo';
import { PermissionContext } from '../../../../../../context/PermissionContext';
import PendingPaymentInfo from './Info/PendingPaymentInfo';
import { SideBarRefreshContext } from '../../../../../../context/SideBarRefreshContext';

const DataReactTable = () => {
  const [pendingData, setPendingData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]); // Track selected booking IDs
  const { permissionsAccess } = useContext(PermissionContext);
  const [showConfirmModal, setShowConfirmModel] = useState(false);
  const [showConfirmAllModal, setShowConfirmAllModel] = useState(false);
  const [showRejectModal, setShowRejectModel] = useState(false);
  const [showRejectAllModal, setShowRejectAllModel] = useState(false);
  const [showInfoHandler, setshowInfoHandler] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [paymentData, setPaymentData] = useState({});
  const [BookingId, setBookingId] = useState('');
  const [BookingId2, setBookingId2] = useState(''); // This is used for the booking info modal
  const [bookingAmount, setBookingAmount] = useState('');
  const [sortOrder, setSortOrder] = useState('asc');
  const [sortColumn, setSortColumn] = useState('pDAte'); // This will track the column being sorted  
  const { apiGlobal, userid, countryid } = useContext(AuthContext);
  const { sideBarRefresh } = useContext(SideBarRefreshContext); 

    // Search filter states
    const [searchAgentName, setSearchAgentName] = useState('');
    const [searchPaymentDate, setSearchPaymentDate] = useState('');
  
  

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const formatDate = (dateString) => {
    if (!dateString) return ''; // Handle empty values
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };

  const fetchPendingData = async () => {
        const formData = new FormData();
        formData.append('country_id', countryid);
    try {
      const url = await fetch(`${apiGlobal}account_pending_list.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await url.json();
      if (data.status && data.message === 'Success') {
        setPendingData(data.data);
      } else {
        setPendingData([]);
        console.error('Something Went Wrong While fetching Payment Pending list');
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchPendingData();
  }, [refresh, sideBarRefresh?.adminPaymentPendingRefresh]);

  const handleBookPaymentApprove = (id, amount) => {
    setShowConfirmModel(true);
    setBookingId(id);
    setBookingAmount(amount);
  };

  const handlebBookPaymentReject = (id) => {
    setShowRejectModel(true);
    setBookingId(id);
  };

  const handleConfirmPayment = async () => {
     const formData = new FormData();
     formData.append('id', BookingId);
     formData.append('isApproved', 1);
     formData.append('country_id', countryid);
    try {
      const url = await fetch(`${apiGlobal}account_payment_confirmation.php?`, {
        method: 'POST',
        body: formData,
      });
      const data = await url.json();
      if (data.status && data.message === 'Success') {
        toast.success('Payment Confirm');
        setRefresh(prev => !prev);
        setBookingId(null);
        setShowConfirmModel(false);
      } else {
        toast.error('Failed to Confirm Payment');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleRejectPayment = async (value) => {
    const formData = new FormData();
    formData.append('id', BookingId);
    formData.append('isApproved', 2);
    formData.append('reason', value.reason);
    formData.append('country_id', countryid);

    try {
      const url = await 
      fetch(`${apiGlobal}account_payment_confirmation.php`, {
        method: 'POST',
        body: formData,
      });
      const response = await url.json();
      if (response.status && response.message === 'Success') {
        toast.success('Reject Successfully');
        setRefresh(prev => !prev);
        setShowRejectModel(false);
      } else {
        toast.error('Failed to Reject Payment');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSort = (column) => {
    const newSortOrder = sortColumn 
    === column && sortOrder === 'asc' ? 'desc' : 'asc'; // Toggle order for the same column
  
    const sortedData = [...pendingData].sort((a, b) => {
      if (column === 'pDAte') {
        return newSortOrder === 'asc'
          ? new Date(a.payment_date) - new Date(b.payment_date)
          : new Date(b.payment_date) - new Date(a.payment_date);
      } if (column === 'sType') {
        return newSortOrder === 'asc'
          ? a.staff_type.localeCompare(b.staff_type)
          : b.staff_type.localeCompare(a.staff_type);
      } if (column === 'sName') {
        return newSortOrder === 'asc'
          ? a.staff_name.localeCompare(b.staff_name)
          : b.staff_name.localeCompare(a.staff_name);
      } if (column === 'amount') {
        const amountA = parseFloat(a.balance); // Convert string balance to number
        const amountB = parseFloat(b.balance); // Convert string balance to number
  
        return newSortOrder === 'asc' ? amountA - amountB : amountB - amountA;
      }
      return 0;
    });
    // console.log(sortedData);
    setPendingData(sortedData);
    setSortOrder(newSortOrder);
    setSortColumn(column); // Update the current sorted column
  };

  

  const handleBookingInfo = (id, bookingid) => {
    setBookingId(id);
    setBookingId2(bookingid);
    setshowInfoHandler(true);
  };

  // Handle individual checkbox selection
  const handleCheckboxChange = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter(selectedId => selectedId !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };


  // Filter logic
  const filteredData = pendingData.filter((agent) => {
    // Check trip name filter

    const matchAgentName = agent.staff_name?.toLowerCase().includes(searchAgentName.toLowerCase());

    // Check Payment date filter
    const matchPaymentDate = agent.payment_date
      ?.toLowerCase()
      .includes(searchPaymentDate.toLowerCase());
    console.log(matchPaymentDate);
    console.log(matchAgentName);
    return matchPaymentDate && matchAgentName;
  });
//   const filteredData = pendingData.filter((agent) => {
//     const matchAgentName = searchAgentName === '' 
//         || agent.staff_name?.toLowerCase().includes(searchAgentName.toLowerCase());
    
//     const matchPaymentDate = searchPaymentDate === '' 
//         || agent.payment_date?.toLowerCase().includes(searchPaymentDate.toLowerCase());
    
//     return matchAgentName && matchPaymentDate;
// });

//  console.log(filteredData);
   
  



  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Pagination Logic - Slice data for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Total pages
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    // Handle "Select All" checkbox
    const handleSelectAll = () => {
      if (selectedIds.length === currentItems.length) {
        setSelectedIds([]); // Deselect all
      } else {
        setSelectedIds(currentItems.map(item => item.id)); // Select all on the current page
      }
    };
  
    const isAllSelected = selectedIds.length === currentItems.length;
    const isIndeterminate = selectedIds.length > 0 && selectedIds.length < currentItems.length;
  

    const handleMultipleAccept = async () => {
      if (selectedIds.length === 0) {
        toast.error('Not Payment Selected');
        return;
      }
      if (!userid) {
        toast.error('User not Found Please log in Again');
        return;
      }

      const formData = new FormData();
      formData.append('isApproved', 1);
      formData.append('ids', JSON.stringify(selectedIds));
      formData.append('user_id', userid);
      formData.append('country_id', countryid);

      try {
        const url = await 
        fetch(`${apiGlobal}account_payment_confirmation_multiple.php`, {
          method: 'POST',
          body: formData,
        });
        const response = await url.json();
        if (response.status && response.message === 'Success') {
          toast.success('Payment Confirm');
          fetchPendingData();
          setSelectedIds([]);
          setShowConfirmAllModel(false);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error(error);
      }
    };



    const handleRejectAllPayment = async (value) => {
      if (selectedIds.length === 0) {
        toast.error('Not Payment Selected');
        return;
      }
      if (!userid) {
        toast.error('User not Found Please log in Again');
        return;
      }
      const formData = new FormData();
      formData.append('isApproved', 2);
      formData.append('ids', JSON.stringify(selectedIds));
      formData.append('user_id', userid);
      formData.append('reason', value.reason);
      formData.append('country_id', countryid);


      try {
        const url = await 
        fetch(`${apiGlobal}account_payment_confirmation_multiple.php`, {
          method: 'POST',
          body: formData,
        });
        const response = await url.json();
        if (response.status && response.message === 'Success') {
          toast.success('Reject Successfully');
          fetchPendingData();
          setSelectedIds([]);
          setShowRejectAllModel(false);
        } else {
          toast.error('Failed to Reject Payment');
        }
      } catch (error) {
        console.error(error);
      }
    };


      // use Effect to add keyframes for the pulse animation
  useEffect(() => {
    // Add keyframes via JavaScript when component mounts
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.2); opacity: 0.8; }
        100% { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }, []);


    

    

  return (
    <div>
      {/* Search Filters */}
      <div
        className="mb-4"
        style={{
          padding: '15px',
          borderRadius: '8px',
          backgroundColor: '#f8f9fa',
          display: 'flex',
          justifyContent: 'flex-start',
          gap: '10px', // Add gap between the input fields
          alignItems: 'center', // Vertically align input fields and button
          flexWrap: 'wrap', // Make sure the filters stay in a single line
        }}
      >
        <h5
          className="mb-2"
          style={{
            color: '#495057',
            alignSelf: 'center',
            marginRight: '20px',
            fontWeight: '600',
          }}
        >
          Filter Payment
        </h5>
        <InputGroup className="mb-2" style={{ maxWidth: '200px' }}>
          <Form.Control
            type="text"
            placeholder="Search by Agent Name"
            value={searchAgentName}
            onChange={e => setSearchAgentName(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup>

        <InputGroup className="mb-2" style={{ maxWidth: '160px' }}>
          <Form.Control
            type="date"
            placeholder="Start Date"
            value={searchPaymentDate}
            onChange={e => setSearchPaymentDate(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup>
        <Button
          variant="outline-danger"
          style={{
            borderRadius: '25px',
            padding: '8px 16px',
            marginLeft: '10px',
            alignSelf: 'center',
          }}
          className="mt-3"
          onClick={() => {
            setSearchAgentName('');
            setSearchPaymentDate('');
          }}
        >
          Clear Filters
        </Button>
        <Button
          variant="outline-danger"
          style={{
            borderRadius: '25px',
            padding: '8px 16px',
            marginLeft: '2px',
            alignSelf: 'center',
          }}
          className="mt-3"
          onClick={() => {
            setRefresh(prev => !prev);
          }}
        >
          Refresh
        </Button>
        {
       selectedIds.length > 0 && (
       <React.Fragment>
         <Button
           style={{
            borderRadius: '25px',
            padding: '8px 16px',
            marginLeft: '10px',
            alignSelf: 'center',
          }}
           className="mt-3"
           variant="outline-success"
           title="Accept All"
           size="sm"
           onClick={() => setShowConfirmAllModel(true)}
         >
           Accept All
         </Button>
         <Button
           style={{
            borderRadius: '25px',
            padding: '8px 16px',
            alignSelf: 'center',
          }}
           className="mt-3"
           variant="outline-danger"
           title="Reject All"
           size="sm"
           onClick={() => setShowRejectAllModel(true)}
         >
           Reject All
         </Button>
       </React.Fragment>

       )


       }
        
       
        
      </div>
      <Table
        responsive
        style={{
          backgroundColor: '#f9f9f9',
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        <thead className="bg-primary" style={{ color: 'white', textAlign: 'center' }}>
          <tr>

            {permissionsAccess?.[5]?.master_id === '6'
                          && permissionsAccess?.[5]?.approval === 1 && (
                          <th>
                            <input
                              type="checkbox"
                              checked={isAllSelected}
                              onChange={handleSelectAll}
                              ref={(input) => {
    if (input) {
      const checkbox = input; // Assign to a local variable
      checkbox.indeterminate = isIndeterminate; // Modify the local variable
    }
  }}
                            />


                          </th>
                          )}
            
            <th 
              onClick={() => handleSort('pDAte')}
              style={{ cursor: 'pointer' }}
            >Payment Date {sortColumn === 'pDAte' 
            && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)}
            </th>
            <th
              onClick={() => handleSort('sType')}
              style={{ cursor: 'pointer' }}
            >
              Staff Type {sortColumn === 'sType' 
              && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)}
            </th>
            <th
              onClick={() => handleSort('sName')}
              style={{ cursor: 'pointer' }}
            >
              Staff Name {sortColumn === 'sName' 
              && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)}
            </th>
            <th
              onClick={() => handleSort('amount')}
              style={{ cursor: 'pointer' }}
            >Booking Amount {sortColumn === 'amount' 
            && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)}
            </th>
            <th>Info</th>
            {permissionsAccess?.[5]?.master_id === '6'
                          && permissionsAccess?.[5]?.approval === 1 && (
                            <th>Action</th>
                          )}
          </tr>
        </thead>
        <tbody>
          {currentItems.length === 0 ? (
            // Render this message if there is no data
            <tr>
              <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{
                               textAlign: 'center',
                   padding: '50px',
                   backgroundColor: '#f8d7da',
                   borderRadius: '8px',
                   marginTop: '20px',
                               color: '#721c24',
                   fontSize: '16px',
                             }}
                >
                  <div
                    style={{
               fontSize: '48px',
               marginBottom: '20px',
               color: '#e63946',
               animation: 'pulse 1.5s infinite ease-in-out',
               display: 'inline-block',
               }}
                  >
                    <FaExclamationCircle />
                  </div>
                  <p>No Pending Payment Data available</p>
                </div>
                {/* <h3>No Pending Data Available</h3> */}
              </td>
            </tr>
          ) : (
            currentItems.map((booking, index) => (
              <tr
                key={booking.id}
                style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f2f2f2', textAlign: 'center' }}
              >
                {permissionsAccess?.[5]?.master_id === '6'
                          && permissionsAccess?.[5]?.approval === 1 && (
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedIds.includes(booking.id)}
                              onChange={() => handleCheckboxChange(booking.id)}
                            />
                          </td>
                          )}
                
                <td>{formatDate(booking.payment_date)}</td>
                <td>{booking.staff_type}</td>
                <td>{booking.staff_name}</td>
                <td>{booking.balance}</td>
                <td>
                  <Button 
                    variant="outline-primary" 
                    title="info"
                    onClick={() => {
                      handleBookingInfo(booking.id, booking.booking_id);
                      setPaymentData({
                        paytype: booking.payment_type || 'NA',
                        paymentDate: booking.payment_date || 'NA',
                        paymentAmount: booking.in_amount || 'NA',
                        totalAmount: booking.total_amount || 'NA',
                        refNo: booking.ref_no || 'NA',
                        narration: booking.narration || 'NA',
                        bankName: booking.bank || 'NA',
                        chequeDate: booking.ref_date || 'NA',
                      });
                    }}                    
                    size="sm"
                  >
                    <span className="lnr lnr-eye" />
                  </Button>
                </td>
                {permissionsAccess?.[5]?.master_id === '6'
                          && permissionsAccess?.[5]?.approval === 1 && (
                            <td>
                              <Button
                                variant="outline-success"
                                title="Accept"
                                size="sm"
                                onClick={() => handleBookPaymentApprove(booking.id, booking.balance)}
                              >
                                Accept
                              </Button>

                              <Button 
                                variant="outline-danger" 
                                title="Reject"
                                onClick={() => handlebBookPaymentReject(booking.id)}
                                size="sm"
                              >
                                Reject
                              </Button>
                            </td>
                          )}
              </tr>
            ))
          )}
        </tbody>
      </Table>

      {/* Pagination Controls */}
      <div style={{
          bottom: '20px',
          right: '20px',
          zIndex: 999,
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        {currentItems.length !== 0 && (
        <Pagination>
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {Array.from({ length: totalPages }, (_, index) => (
            <Pagination.Item
              key={index + 1}
              active={index + 1 === currentPage}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
 ))}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
        )}
       
      </div>

      {/* Confirmation Modal */}
      <ComfirmationModel
        show={showConfirmModal}
        handleClose={() => setShowConfirmModel(false)}
        message="Are you sure you want to approve this payment?"
        amount={bookingAmount}
        handleApproved={handleConfirmPayment}
        header="Approve Payment"
      />

      {/* Confirmation Modal for all Accept */}
      <ComfirmationModel
        show={showConfirmAllModal}
        handleClose={() => setShowConfirmAllModel(false)}
        message="Are you sure you want to approve All this selected payment?"
        handleApproved={handleMultipleAccept}
        header="Approve All Payment"
      />
      



      <Modal
        show={showRejectModal}
        onHide={() => setShowRejectModel(false)}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Reject Remark</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RejectReasonForm onSubmit={value => handleRejectPayment(value)} text="Payment" />
        </Modal.Body>
      </Modal>

      {/* Modal for Reject all Payment Request */}
      <Modal
        show={showRejectAllModal}
        onHide={() => setShowRejectAllModel(false)}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Reject Remark</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RejectReasonForm onSubmit={value => handleRejectAllPayment(value)} text="Payment" />
        </Modal.Body>
      </Modal>

      <Modal
        show={showInfoHandler}
        onHide={() => {
          setshowInfoHandler(false);
          setPaymentData({});
        }}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>{BookingId !== '0' ? 'Booking & Payment Info' : 'Payment Info'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PendingPaymentInfo 
            bookingID={BookingId}
            BookingId2={BookingId2}
            paymentData={paymentData}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default DataReactTable;
